module.exports = __webpack_public_path__ + "img/Back1.47aaf07.svg";